import React, {useState} from 'react'
import * as Yup from 'yup';
import {ErrorMessage, Form, Formik} from 'formik';

import {Dialog, DialogActions, DialogContent, DialogTitle, Grid,} from '@mui/material'
import Button from "../../../../components/CustomButtons/Button";
import {history} from '../../../../helpers/history';

import {DarkerDisabledTextField, useStyles} from './styles';

const SectionDetails = props => {
  const {
    title,
    initialSection,
    onHandleSubmit,
    submitButton
  } = props

  let open = true;
  let required = false;
  let disabled = true;
  if (submitButton !== 'View'){
    required = true;
    disabled = false;
  }

  const classes = useStyles();
  const [values] = useState(initialSection);

  return(
    <Formik
      initialValues={values}
      onReset= {() => {
        history.push('/section');
      }}
      onSubmit={(values, {setSubmitting, setValues, setErrors, setFieldError}) => {
        setSubmitting(true);
        if (onHandleSubmit(values)) {
          setSubmitting(false);
          if (submitButton === 'Add') {
            setValues(initialSection);
          } else {
            history.push('/section');
          }
        } else {
          setErrors('Section update not successful');
          setFieldError('name', 'Section already on file');
        }
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string()
          .trim()
          .min(3)
          .when('$required', (required, requireSchema) => required
            ? requireSchema
            : requireSchema).required('Section Name is Required'),

      })}
    >
      {(props) => {
        const {
          values,
          isSubmitting,
          handleChange,
          handleBlur,
          handleReset,
          handleSubmit
        } = props;

        return (
          <Form onSubmit={handleSubmit}>
            <Dialog
              aria-labelledby="form-dialog-title"
              onClose={handleReset}
              open={open}
            >
              <DialogTitle id="form-dialog-title">{ title }</DialogTitle>
              <DialogContent>
                {/*<DialogContentText>Add Section</DialogContentText>*/}
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <DarkerDisabledTextField
                      autoFocus
                      disabled ={disabled}
                      fullWidth
                      label="Section Name"
                      margin="dense"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required = {required}
                      type="text"
                      value={values.name || ''}
                    />
                    <ErrorMessage
                      className={classes.errorMessage}
                      component="div"
                      name="name"
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  color="github"
                  disabled={isSubmitting}
                  onClick={handleReset}
                >
                  Cancel
                </Button>
                {disabled
                  ? null
                  : (<Button
                    onClick={handleSubmit}
                      color="primary"
                      disabled={isSubmitting}
                     >
                    {submitButton}
                  </Button>)
                }
              </DialogActions>
            </Dialog>
          </Form>
        )}
      }

    </Formik>
  )
}

export default SectionDetails;
